import {
  FORM_CONTROL_ID,
  VIEW_MODE_CONTAINER_ID,
  LABEL_ID,
  COMBO_BOX_INPUT_ID,
  COMBO_BOX_LIST_ID,
  COMBO_BOX_LIST_ITEM_ID,
  COMBO_BOX_CHIP_ID,
  ARIA_COMBO_BOX_LABEL,
} from '../constants/locators';

type UseDropdownLocatorProps = {
  key: string;
};

export const useComboBoxLocators = ({ key }: UseDropdownLocatorProps) => {
  return {
    formControlNodeId: `${FORM_CONTROL_ID}--${key}`,
    viewModeContainerNodeId: `${VIEW_MODE_CONTAINER_ID}--${key}`,
    labelNodeId: `${LABEL_ID}--${key}`,
    comboBoxInputNodeId: `${COMBO_BOX_INPUT_ID}--${key}`,

    listNodeId: `${COMBO_BOX_LIST_ID}--${key}`,
    listItemNodeId: `${COMBO_BOX_LIST_ITEM_ID}--${key}`,

    chipNodeId: `${COMBO_BOX_CHIP_ID}--${key}`,

    ariaComboBoxLabel: `${ARIA_COMBO_BOX_LABEL}--${key}`,
  };
};
